"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
__export(require("./Alert"));
__export(require("./Archive"));
__export(require("./BasicResponse"));
__export(require("./BasicResult"));
__export(require("./Channel"));
__export(require("./ChannelAction"));
__export(require("./ChannelCondition"));
__export(require("./ChannelPermissions"));
__export(require("./ChannelTriggersWithActions"));
__export(require("./ErrorResponse"));
__export(require("./Instrument"));
__export(require("./MeasuredProperty"));
__export(require("./MeasurementValues"));
__export(require("./Measurements"));
__export(require("./NewArchive"));
__export(require("./NewArchiveSettings"));
__export(require("./NewRole"));
__export(require("./Ontology"));
__export(require("./Project"));
__export(require("./ReqAddOntology"));
__export(require("./ReqCreateChannel"));
__export(require("./ReqCreateChannelAction"));
__export(require("./ReqCreateChannelCondition"));
__export(require("./ReqCreateChannelTriggersWithActions"));
__export(require("./ReqCreateInstrument"));
__export(require("./ReqCreateMeasurement"));
__export(require("./ReqCreateProject"));
__export(require("./ReqCreateSite"));
__export(require("./ReqCreateTemplate"));
__export(require("./ReqCreateVariable"));
__export(require("./RespAddOntology"));
__export(require("./RespArchiveProject"));
__export(require("./RespCreateChannels"));
__export(require("./RespCreateInstrument"));
__export(require("./RespCreateMeasurement"));
__export(require("./RespCreateProject"));
__export(require("./RespCreateSite"));
__export(require("./RespCreateTemplate"));
__export(require("./RespCreateVariable"));
__export(require("./RespDeleteChannel"));
__export(require("./RespDeleteInstrument"));
__export(require("./RespDeleteOntology"));
__export(require("./RespDeleteProject"));
__export(require("./RespDeleteSite"));
__export(require("./RespDeleteVariable"));
__export(require("./RespDownloadMeasurements"));
__export(require("./RespGetChannel"));
__export(require("./RespGetInstrument"));
__export(require("./RespGetOntology"));
__export(require("./RespGetProject"));
__export(require("./RespGetSite"));
__export(require("./RespGetTemplate"));
__export(require("./RespGetVariable"));
__export(require("./RespGrantRole"));
__export(require("./RespHealthcheck"));
__export(require("./RespHello"));
__export(require("./RespListAlerts"));
__export(require("./RespListArchives"));
__export(require("./RespListChannels"));
__export(require("./RespListInstruments"));
__export(require("./RespListMeasuredProperties"));
__export(require("./RespListMeasurements"));
__export(require("./RespListOntologies"));
__export(require("./RespListProjects"));
__export(require("./RespListRoles"));
__export(require("./RespListSites"));
__export(require("./RespListTemplates"));
__export(require("./RespListUnits"));
__export(require("./RespListVariables"));
__export(require("./RespReady"));
__export(require("./RespRevokeRole"));
__export(require("./RespTransferData"));
__export(require("./RespUpdateChannel"));
__export(require("./RespUpdateInstrument"));
__export(require("./RespUpdateOntology"));
__export(require("./RespUpdateProject"));
__export(require("./RespUpdateSite"));
__export(require("./RespUpdateStatus"));
__export(require("./RespUpdateTemplate"));
__export(require("./RespUpdateVariable"));
__export(require("./RevokeRole"));
__export(require("./Roles"));
__export(require("./Site"));
__export(require("./Template"));
__export(require("./Transfer"));
__export(require("./Unit"));
__export(require("./UpdateChannelStatus"));
__export(require("./UpdateInst"));
__export(require("./UpdateTemplate"));
__export(require("./Variable"));
